import { CalendarPage } from './calendar/calendarPage';
import React, { useCallback, useEffect, useState } from 'react';
import { JobLogsType, JobsType, ModalMode } from './types';
import { useProducerWithThunks } from 'common/hooks/useProducer';
import {
  CancelJobsActions,
  CreateJobsActions,
  JobLogsActions,
  JobsActions,
} from 'common/state/jobs/actions';
import {
  JobsState,
  defaultJobsState,
  defaultJobState,
  JobState,
  defaultJobLogsState,
  JobLogsState,
} from 'common/state/jobs/states';
import {
  cancelJobsRecipe,
  createJobsRecipe,
  jobLogsRecipe,
  jobsRecipe,
} from 'common/state/jobs/recipes';
import { CreateJobsBodyData } from 'common/state/jobs/thunkActions';
import { JobModal } from './modals/jobModal';
import { CreateModal } from './modals/createModal';
import { PendingPage } from './pending/pending';
import { ThemedModal } from 'common/components/cardStyles';
import { SubNav, Ul, Li, StyledSubNavLink } from 'features/nav/subNav';
import FadeIn from 'react-fade-in';
import { Switch, Route, Redirect } from 'react-router';

export const Scrapers = () => {
  const [jobs, setJobs] = useState<JobsType>({});
  const [logs, setLogs] = useState<JobLogsType>({});
  const [modalMode, setModalMode] = useState<ModalMode>();
  const [focusedJob, setFocusedJob] = useState<number>();
  const [createInitialData, setCreateInitialData] = useState<
    Partial<CreateJobsBodyData>
  >({});
  const [jobsState, jobsDispatch] = useProducerWithThunks<
    JobsState,
    JobsActions
  >(jobsRecipe, defaultJobsState);
  const [logsState, logsDispatch] = useProducerWithThunks<
    JobLogsState,
    JobLogsActions
  >(jobLogsRecipe, defaultJobLogsState);
  const [createJobsState, createJobsDispatch] = useProducerWithThunks<
    JobsState,
    CreateJobsActions
  >(createJobsRecipe, defaultJobsState);
  const [cancelJobState, cancelJobDispatch] = useProducerWithThunks<
    JobState,
    CancelJobsActions
  >(cancelJobsRecipe, defaultJobState);

  useEffect(() => {
    if (createJobsState.jobs)
      setJobs(
        createJobsState.jobs?.reduce(
          (acc, job) => ({ ...acc, [job.id]: job }),
          {
            ...jobs,
          }
        ) || []
      );
    // eslint-disable-next-line
  }, [createJobsState.jobs]);

  useEffect(() => {
    if (jobsState.jobs)
      setJobs(
        jobsState.jobs?.reduce((acc, job) => ({ ...acc, [job.id]: job }), {
          ...jobs,
        }) || []
      );
    // eslint-disable-next-line
  }, [jobsState.jobs]);

  useEffect(() => {
    if (logsState.logs)
      setLogs({
        ...logs,
        [logsState.id]: logsState.logs,
      });
    // eslint-disable-next-line
  }, [logsState.logs]);

  useEffect(() => {
    if (cancelJobState.job)
      setJobs({
        ...jobs,
        [cancelJobState.job.id]: cancelJobState.job,
      });
    // eslint-disable-next-line
  }, [cancelJobState.job]);

  const closeModal = useCallback(() => setModalMode(null), [setModalMode]);

  return (
    <div style={{ width: '100vw' }}>
      <SubNav>
        <Ul>
          <Li>
            <StyledSubNavLink to="/scrapers/calendar">
              <div>Calendar</div>
            </StyledSubNavLink>
          </Li>
          <Li>
            <StyledSubNavLink to="/scrapers/pending">
              <div>Pending</div>
            </StyledSubNavLink>
          </Li>
        </Ul>
      </SubNav>
      <Switch>
        <Route path="/scrapers/pending">
          <FadeIn>
            <PendingPage
              jobs={jobs}
              jobsDispatch={jobsDispatch}
              setModalMode={setModalMode}
              setFocusedJob={setFocusedJob}
            />
          </FadeIn>
        </Route>
        <Route path="/scrapers/calendar">
          <FadeIn>
            <CalendarPage
              jobs={jobs}
              jobsDispatch={jobsDispatch}
              setModalMode={setModalMode}
              setFocusedJob={setFocusedJob}
              setCreateInitialData={setCreateInitialData}
            />
          </FadeIn>
        </Route>
        <Route render={() => <Redirect to="/scrapers/calendar" />} />
      </Switch>
      <ThemedModal open={modalMode != null}>
        {modalMode === 'job' && (
          <JobModal
            job={jobs[focusedJob]}
            logs={logs[focusedJob]}
            setModalMode={setModalMode}
            setCreateInitialData={setCreateInitialData}
            jobsDispatch={jobsDispatch}
            logsDispatch={logsDispatch}
            cancelJobState={cancelJobState}
            cancelJobDispatch={cancelJobDispatch}
            closeModal={closeModal}
          />
        )}
        {modalMode === 'create' && (
          <CreateModal
            initialData={createInitialData}
            state={createJobsState}
            dispatch={createJobsDispatch}
            closeModal={closeModal}
          />
        )}
      </ThemedModal>
    </div>
  );
};
